import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import NotificationContainer from '@spothero/ui/notification-container';
import NotificationPropTypes from '@spothero/ui/notification-prop-types';
import {clearNotification} from 'notification/notification-actions';
import {userUpdate} from 'user/user-actions';
import AppRouter from 'common/router/AppRouter';
import RouterLoader from 'common/router/RouterLoader';
import HeaderMobile from 'header/HeaderMobile';
import HeaderCheckout from 'header/HeaderCheckout';
import Footer from 'footer/Footer';
import FooterCheckout from 'footer/FooterCheckout';

class AppMobile extends Component {
    static propTypes = {
        updateUser: PropTypes.func.isRequired,
        notification: PropTypes.shape(NotificationPropTypes),
        clearNotifications: PropTypes.func.isRequired,
        pageType: PropTypes.string,
        destination: PropTypes.object,
        isMonthly: PropTypes.bool.isRequired,
        user: PropTypes.object.isRequired,
        isRouteLoading: PropTypes.bool.isRequired
    };
    
    constructor(props) {
        super(props);

        const {
            user,
            updateUser
        } = props;

        updateUser(user);
    }

    render() {
        const {
            notification,
            clearNotifications,
            pageType,
            user,
            destination,
            isMonthly,
            isRouteLoading
        } = this.props;
        const {
            isCheckoutHeadersFooters
        } = user;
        const isCheckoutHeadersFootersExperiment = (pageType === 'checkout') && isCheckoutHeadersFooters;
        const hiddenClassName = (isRouteLoading) ? 'hidden' : null;

        return (
            <div className="AppMobile">
                <NotificationContainer
                    notification={notification}
                    onQueueEmpty={clearNotifications}
                />
                {(isCheckoutHeadersFootersExperiment)
                    ? (
                        <HeaderCheckout
                            className={hiddenClassName}
                        />
                    ) : (
                        <HeaderMobile
                            className={hiddenClassName}
                            isCheckoutHeadersFootersExperiment={isCheckoutHeadersFootersExperiment}
                        />
                    )
                }
                {(isRouteLoading)
                    ? (
                        <RouterLoader />
                    ) : (
                        <AppRouter
                            isMobile
                            pageType={pageType}
                            user={user}
                            destination={destination}
                            isMonthly={isMonthly}
                        />
                    )
                }
                {(isCheckoutHeadersFootersExperiment)
                    ? (
                        <FooterCheckout
                            className={hiddenClassName}
                        />
                    ) : (
                        <Footer
                            className={hiddenClassName}
                            email={user.email}
                        />
                    )
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {
        destination: {
            data: destinationData
        },
        notification,
        searchRequest: {
            pageType,
            monthly: isMonthly
        },
        user: {
            data: userData
        },
        searchRequest: {
            isRouteLoading
        }
    } = state;

    return {
        destination: destinationData,
        notification,
        user: userData,
        pageType,
        isMonthly,
        isRouteLoading
    };
};

const mapDispatchToProps = {
    updateUser: userUpdate,
    clearNotifications: clearNotification
};

export default connect(mapStateToProps, mapDispatchToProps)(AppMobile);
